export enum AnnouncementStatusEnum{
    Active = 1,
    Inactive = 2,
    Expired = 3,
    Canceled = 4,
    Pending = 5,
    Rejected = 6
}